/**
 *
 *
 * Shared constants
 *
 *
 */
export const ERROR_MSGS = {
  CLIENT_COMM:
    "There was an issue retrieving client communication information.",
  STATUS_UPDATE: "There was an issue updating the status of the response.",
  LOGIN: "There was an error logging the client in.",
  DOCUMENT_CLIENT_INFO:
    "There was an issue retrieving document/client information.",
  STATUS_UPDATE_INPROGRESS:
    "There was an issue setting the status of the response to 'InProgress'",
  STATUS_UPDATE_COMPLETE:
    "There was an issue setting the status of the response to 'Complete'",
  POST_RESPONSE: "There was an issue creating a new client response",
  UPDATE_RESPONSE: "There was an issue update a client response",
};

export const FUNC_DELAY = { CHANGE: 235 };
export const FORM_DELAY = { CHANGE: 500 };

// Local storage keys
export const FIRM_NAME_KEY = "firmname";
export const FIRM_CODE_KEY = "firmcode";
export const EMAIL_KEY = "email";
